import z from 'zod';

export type PurchaseOrderListMode = 'active' | 'cancelled';

export const isPurchaseOrderInListMode = (
  status: string,
  listMode: PurchaseOrderListMode,
) =>
  listMode === 'cancelled' ? status === 'CANCELLED' : status !== 'CANCELLED';

export const canEditPurchaseOrder = (status: string) => status === 'DRAFT_PO';

export const canPermanentlyDeletePurchaseOrder = (status: string) =>
  status === 'DRAFT_PO' || status === 'CANCELLED';

export const canCancelPurchaseOrder = (status: string) =>
  ['DRAFT_PO', 'ISSUED', 'CONFIRMED'].includes(status);

export const mustCancelBeforeDeletingPurchaseOrder = (status: string) =>
  ['ISSUED', 'CONFIRMED'].includes(status);

export const isPurchaseOrderInvoiceReadOnly = (status: string) =>
  status === 'CANCELLED';

export const buildPurchaseOrderDeleteConfirmationSchema = (
  confirmationNumber: string,
) =>
  z.object({
    confirmation: z
      .string()
      .refine((value) => value.trim() === confirmationNumber, {
        error: `Type ${confirmationNumber} exactly to confirm.`,
      }),
  });
